<app-pagetitle title="Planes de Acción" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="container card-body table-responsive">
                <!-- Acordions Objetivos -->
                <div class="row">
                    <div class="col-md-12">
                        <div id="accordion" class="mb-3">
                            <div class="card mb-1" *ngFor="let row of dataPlanAccionObjetivos; let indiceUno=index">
                                <div class="card-header py-0 px-0 my-0" id="headingNine">
                                    <h5 class="accordion-header py-0" id="headingOne">
                                        <a class="accordion-button py-2 text-reset" data-bs-toggle="collapse"
                                            href="#id_{{ indiceUno + 1 }}" aria-expanded="true" aria-expanded="true"
                                            aria-controls="collapseOne">
                                            {{"OBJETIVO " + (indiceUno+1) +".- "}}{{ row.nombreObjetivo }}
                                        </a>
                                    </h5>
                                </div>
                                <div id="id_{{indiceUno + 1}}" class="collapse" aria-labelledby='abcd'
                                    data-bs-parent="#accordion">
                                    <div class="card-body">

                                        <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.PLANES_ACCION}">
                                            <div class="col-sm-6 text-sm-right">

                                                <button
                                                    *hasPermission="{app: constant.PLANES_ACCION, permission: [constant.CREAR, constant.CREAR]}"
                                                    type="button" class="btn btn-sm btn-success waves-effect pl-4"
                                                    (click)="openModal(row)"><i class="fas fa-plus fa-lg mr-1"></i>
                                                    Nuevo</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="container card-body table-responsive pt-2">
                                        <table class="table table-striped table-bordered row-border hover">
                                            <thead>
                                                <tr>
                                                    <th colspan="4"></th>
                                                    <th colspan="4" class="text-center">Indicadores</th>
                                                    <th colspan="5"></th>
                                                </tr>
                                                <tr>
                                                    <th>Nro.</th>
                                                    <th>Plan de Acción</th>
                                                    <th><i class="fa fa-square  m-r-10" style='color: red'></i></th>
                                                    <th><i class="fa fa-circle m-r-10" style='color: green'></i></th>
                                                    <th><i class="fa fa-exclamation-triangle m-r-10"style='color: orange'></i></th>
                                                    <th><i class="fa fa-stop" style='color: blue'></i></th>
                                                    <th>Nro. Riesgo</th>
                                                    <th>Nro. Actividades</th>
                                                    <th>Estado</th>
                                                    <th>Seguimiento/ Actividades</th>
                                                    <th>Acciónes</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let rowDataPlan of dataPlanAccionObjetivos[indiceUno].planAccion; let indice=index">
                                                    <td>{{indice+1}}</td>

                                                    <td class="plan-column" style="max-width: 300px; word-wrap: break-word; white-space: normal;">{{ rowDataPlan.nombrePlanAccion }}
                                                    </td>
                                                    <td>1</td>
                                                    <td>1</td>
                                                    <td>1</td>
                                                    <td>1</td>
                                                    <td *ngIf="totalRiesgos(rowDataPlan.idSprPlanAccion,dataRiesgos).length != undefined">{{totalRiesgos(rowDataPlan.idSprPlanAccion,dataRiesgos).length}}</td>
                                                    <td *ngIf="totalActividades(rowDataPlan.idSprPlanAccion,dataActividades).length != undefined">{{totalActividades(rowDataPlan.idSprPlanAccion,dataActividades).length}}
                                                    </td>

                                                    <td>{{ rowDataPlan.estado == "1" ? "Activo" : "Inactivo" }}</td>
                                                    <td class="text-center">
                                                        <div class="row">
                                                            <button type="button" tooltip="Editar"
                                                                class="btn btn-sm btn-link waves-effect rounded-pill"
                                                                title="Agregar actividades"
                                                                (click)="modalActividades(rowDataPlan)">
                                                                <i class="fas fa-tasks fa-lg"></i>
                                                            </button>
                                                        </div>
                                                    </td>

                                                    <td class="text-center">
                                                        <div class="row"
                                                            *hasDenied="{nivel:idSprNivel, app: constant.PLANES_ACCION}">
                                                            <button
                                                                *hasPermission="{app: constant.PLANES_ACCION, permission: [constant.ACTUALIZAR]}"
                                                                type="button" tooltip="Editar"
                                                                class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                                                title="Editar este registro"
                                                                (click)="updatePlanAccion(rowDataPlan, row)">
                                                                <i class="fas fa-pencil-alt fa-lg"></i>
                                                            </button>
                                                            <button
                                                                *hasPermission="{app: constant.PLANES_ACCION, permission: [constant.BORRAR]}"
                                                                type="button"
                                                                class="btn btn-sm btn-link waves-effect col px-0"
                                                                title="Eliminar este registro" (click)="delete(rowDataPlan)">
                                                                <i class="fas fa-trash-alt fa-lg"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-objetivo" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>

<!-- ############################################################################################################# -->
<!-- ######################################    MODALES       ##################################################### -->
<!-- ############################################################################################################# -->

<jw-modal id="{{nameModal}}" #modalChild>
    <!-- MODAL PARA CREAR Y EDITAR -->
    <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top: 6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{ nameApp }}</h3>

                <button type="button" class="btn-close" (click)="closeModalPlanesAccion()" aria-label="Close"></button>
            </div>
            <div class="modal-body pT-4">
                <div class="card-header  mb-2">
                    <div class="form-group row mb-2">
                        <div class="pservices text-justify">
                            <span><b>OBJETIVO: </b>{{ nombreObjetivos }}</span>
                          </div>
                    </div>
                </div>
                <form action="#" [formGroup]="formPlanAccion" class="needs-validation">

                    <div class="row">
                        <div class="form-group row mb-2">
                            <div class="col col-md-2 text-md-right ">
                                <input type="hidden" id formControlName="idSprPlanAccion" requiered class="is-invalid" />
                                <label for="nombre" class="col-form-label text-md-right"><b>Nombre:</b></label>
                            </div>
                            <div class="col-12 col-md-10 ">
                              <textarea id="nombre" type="text" class="form-control" required="true" formControlName="nombre"[ngClass]="{ 'is-invalid': this.formPlanAccion.get('nombre')?.errors && this.submitted,'is-valid': !this.formPlanAccion.get('nombre')?.errors,}"style="height: 78px;">
                                  </textarea>
                                <small class="invalid-feedback" *ngIf="this.formPlanAccion.get('nombre')?.errors?.['required'] && this.submitted">Campo requerido</small>
                            </div>
                        </div>

                        <div id="accordion1" class="mb-3">
                            <div class="card mb-1">
                                <div class="card-header py-0 px-0 my-0" id="heading1">
                                    <h5 class="accordion-header py-0" id="heading1">
                                        <a class="accordion-button py-2 text-reset" data-bs-toggle="collapse" href="#localImpacto" aria-expanded="true" aria-expanded="true" aria-controls="collapseOne">{{"Localización"}}</a>
                                    </h5>
                                </div>
                                <div id="localImpacto" class="collapse" aria-labelledby='heading1' data-bs-parent="#accordion3">
                                    <div class="card-body">
                                        <div class="row ">
                                            <div class="col-md-6">
                                                <h4 class="header-title">Estructura organizacional</h4>
                                                <div class="card flex justify-content-center">
                                                    <p-tree [value]="unidades" [filter]="true" selectionMode="single" [(selection)]="selectedFile" (onNodeSelect)="nodeSelect($event)" scrollHeight="300px" (onNodeExpand)="nodeExpand($event)">
                                                    </p-tree>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                              <h4 class="header-title">Datos localidad impacto</h4>
                                              <div class="form-floating mb-2">
                                                <textarea type="text" id="localidadImpacto" class="form-control form-control-sm" formControlName="localidadImpacto"
                                                  [ngClass]="{ 'is-invalid': this.formPlanAccion.get('localidadImpacto')?.errors && this.submitted,'is-valid': !this.formPlanAccion.get('localidadImpacto')?.errors,}">
                                                </textarea>
                                                <label for="localidadImpacto">Nombre</label>
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="accordion2" class="mb-3">
                            <div class="card mb-1">
                                <div class="card-header py-0 px-0 my-0" id="heading2">
                                    <h5 class="accordion-header py-0" id="heading2">
                                        <a class="accordion-button py-2 text-reset" data-bs-toggle="collapse" href="#tiempoCiclo" aria-expanded="true" aria-expanded="true" aria-controls="collapseTwo">{{"Tiempo Ciclo"}}</a>
                                    </h5>
                                </div>
                                <div id="tiempoCiclo" class="collapse" aria-labelledby='heading2' data-bs-parent="#accordion1">
                                    <div class="card-body">
                                        <div class="form-group row mb-2">
                                            <div class=" col col-md-2 text-md-right">
                                                <label for="fechaInicio" class=" form-control-label text-md-right pt-1"><b>Fecha inicio:</b></label>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <input type="date" class="form-control" required="true" placeholder="fechaInicio" formControlName="fechaInicio"
                                                    [ngClass]="{'is-invalid': this.formPlanAccion.get('fechaInicio')?.errors && this.submitted,'is-valid': !this.formPlanAccion.get('fechaInicio')?.errors,}" />
                                                <small class="invalid-feedback" *ngIf="this.formPlanAccion.get('fechaInicio')?.errors?.['required'] && this.submitted">Campo requerido</small>
                                                <div class="col text-danger">
                                                    <span class="font-italic" *ngIf="this.formPlanAccion.get('fechaInicio').errors?.fechaInicio">La fecha debe estar
                                                        comprendida entre {{this.formPlanAccion.get('fechaInicio')?.errors.fechaInicio}}y{{this.formPlanAccion.get('fechaInicio')?.errors.fechaFin}}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class=" col col-md-2 text-md-right">
                                                <label for="fechaFin" class=" form-control-label text-md-right pt-1"><b>Fecha fin:</b></label>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <input type="date" class="form-control" required="true" placeholder="Fecha Fin" formControlName="fechaFin" [ngClass]="{'is-invalid': this.formPlanAccion.get('fechaFin')?.errors && this.submitted,'is-valid': !this.formPlanAccion.get('fechaFin')?.errors,}" />
                                                <small class="invalid-feedback" *ngIf="this.formPlanAccion.get('fechaFin')?.errors?.['required'] && this.submitted">Campo
                                                    requerido</small>
                                                <div class="col text-danger">
                                                    <span class="font-italic" *ngIf="this.formPlanAccion.get('fechaFin').errors?.fechaFin">La fecha debe estar
                                                        comprendida entre{{this.formPlanAccion.get('fechaFin')?.errors.fechaInicio}}y{{this.formPlanAccion.get('fechaFin')?.errors.fechaFin}}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div id="accordion3" class="mb-3">
                            <div class="card mb-1">
                                <div class="card-header py-0 px-0 my-0" id="heading3">
                                    <h5 class="accordion-header py-0" id="heading3">
                                        <a class="accordion-button py-2 text-reset" data-bs-toggle="collapse" href="#detallePlan" aria-expanded="true" aria-expanded="true" aria-controls="collapseThree">
                                            Detalle Plan Acciòn
                                        </a>
                                    </h5>
                                </div>
                                <div id="detallePlan" class="collapse" aria-labelledby='heading3' data-bs-parent="#accordion2">
                                    <div class="card-body">
                                        <div class="row ">
                                            <div class="form-group row mb-2">
                                                <div class="col col-md-2 text-md-right ">
                                                    <label for="objetivoGeneral" class="col-form-label text-md-right"><b>Objetivo general:</b>
                                                    </label>
                                                </div>
                                                <div class="col-12 col-md-10 ">
                                                    <textarea type="text" class="form-control" required="true" formControlName="objetivoGeneral" maxlength="1500"
                                                        [ngClass]="{ 'is-invalid': this.formPlanAccion.get('objetivoGeneral')?.errors && this.submitted,'is-valid': !this.formPlanAccion.get('objetivoGeneral')?.errors,}">
                                                    </textarea>
                                                    <small class="invalid-feedback" *ngIf="this.formPlanAccion.get('objetivoGeneral')?.errors?.['required'] && this.submitted">Campo requerido</small>
                                                </div>
                                            </div>
                                            <div class="form-group row mb-2">
                                                <div class="col col-md-2 text-md-right ">
                                                    <label for="objetivoEspecifico" class="col-form-label text-md-right"><b>Objetivo especifico:</b>
                                                    </label>
                                                </div>
                                                <div class="col-12 col-md-10 ">
                                                    <textarea type="text" class="form-control" required="true" formControlName="objetivoEspecifico" maxlength="1500"
                                                        oninput="this.value " rows="3" cols="30" [ngClass]="{ 'is-invalid': this.formPlanAccion.get('objetivoEspecifico')?.errors && this.submitted,'is-valid': !this.formPlanAccion.get('objetivoEspecifico')?.errors,}">
                                                    </textarea>
                                                    <small class="invalid-feedback" *ngIf="this.formPlanAccion.get('objetivoEspecifico')?.errors?.['required'] && this.submitted">Campo requerido</small>
                                                </div>
                                            </div>

                                            <div class="form-group row mb-2">
                                                <div class="col col-md-2 text-md-right ">
                                                    <label for="descripcion" class="col-form-label text-md-right"><b>Descripcion:</b>
                                                    </label>
                                                </div>
                                                <div class="col-12 col-md-10 ">
                                                    <textarea type="text" class="form-control" required="true" formControlName="descripcion" maxlength="1500"
                                                        oninput="this.value " rows="3" cols="30" [ngClass]="{ 'is-invalid': this.formPlanAccion.get('descripcion')?.errors && this.submitted,'is-valid': !this.formPlanAccion.get('descripcion')?.errors,}">
                                                    </textarea>
                                                    <small class="invalid-feedback" *ngIf="this.formPlanAccion.get('descripcion')?.errors?.['required'] && this.submitted">Campo requerido</small>
                                                </div>
                                            </div>

                                            <div class="form-group row mb-2">
                                                <div class="col col-md-2 text-md-right ">
                                                    <label for="idSprEquipoGerencial" class="col-form-label text-md-right"><b>Líder del plan de accíon:</b></label>
                                                </div>
                                                <div class="col-12 col-md-4 ">
                                                    <select id="idSprEquipoGerencial" class="form-select" formControlName="idSprEquipoGerencial" required="true"
                                                        [ngClass]="{ 'is-invalid': this.formPlanAccion.get('idSprEquipoGerencial')?.errors && this.submitted,'is-valid': !this.formPlanAccion.get('idSprEquipoGerencial')?.errors,}">
                                                        <option *ngFor="let catEquipo of dataParticipantesElemento" value="{{ catEquipo.idSprEquipoGerencial }}">
                                                            {{catEquipo.gradoNombres}}
                                                        </option>
                                                    </select>
                                                    <small class="invalid-feedback" *ngIf="this.formPlanAccion.get('idSprEquipoGerencial')?.errors?.['required'] && this.submitted">Campo requerido</small>
                                                </div>

                                                <div class="col col-md-2 text-md-right ">
                                                    <label for="idSprTipoPlanAccion" class="col-form-label text-md-right"><b>Tipo de plan de acción:</b></label>
                                                </div>
                                                <div class="col-12 col-md-4 ">
                                                    <select id="idSprTipoPlanAccion" class="form-select" formControlName="idSprTipoPlanAccion" required="true"
                                                        [ngClass]="{ 'is-invalid': this.formPlanAccion.get('idSprTipoPlanAccion')?.errors && this.submitted,'is-valid': !this.formPlanAccion.get('idSprTipoPlanAccion')?.errors,}">
                                                        <option *ngFor="let catTipoPlan of dataTipoPlanAccion" value="{{ catTipoPlan.idSprComun }}">
                                                            {{catTipoPlan.nombre}}
                                                        </option>
                                                    </select>
                                                    <small class="invalid-feedback" *ngIf="this.formPlanAccion.get('idSprTipoPlanAccion')?.errors?.['required'] && this.submitted">Campo requerido</small>
                                                </div>
                                            </div>

                        <div class="form-group row mb-2">
                                                <div class="col col-md-2 text-md-right ">
                                                    <label for="estado" class="col-form-label text-md-right"><b>Estado:</b></label>
                                                </div>
                                                <div class="col-12 col-md-4 ">
                                                    <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{ 'is-invalid': this.formPlanAccion.get('estado')?.errors && this.submitted,'is-valid': !this.formPlanAccion.get('estado')?.errors,}">
                                                        <option value="1" selected>Activo</option>
                                                        <option value="2">Inactivo</option>
                                                    </select>
                                                    <small class="invalid-feedback" *ngIf="this.formPlanAccion.get('estado')?.errors?.['required'] && this.submitted">Campo requerido</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalPlanesAccion()"> Cerrar</button>
                <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>

<jw-modal id="{{modalActividad}}">
    <div class="modal-dialog modal-xl modal-dialog-scrollable" style="padding-top: 6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{ tituloActividad }}</h3>
                <button type="button" class="btn-close" (click)="closeModalActividad(modalActividad)" aria-label="Close"></button>
            </div>
            <div class="modal-body pT-4">
                <app-actividad *ngIf="outDataPlanAccion" [planAccionInput]="outDataPlanAccion"></app-actividad>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalActividad(modalActividad)">Cerrar</button>
            </div>
        </div>
    </div>
</jw-modal>
